<template>
  <div>
    <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
    <sidebar v-if="!isLoginPage"></sidebar>
    <div v-if="!isLoginPage" class="content-container">
      <Header></Header>
    <router-view :key="$route.fullPath"></router-view>
    </div>
    <router-view v-if="isLoginPage"></router-view>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import Header from "./pages/layouts/Header";
import Sidebar from "./pages/layouts/Sidebar";

export default {
  components: {
    Loading, Header, Sidebar,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      loader: 'bars',
      isLoginPage: false,
    };
  },
  created(){
     if(this.$router.currentRoute.path=='/login'){
      if(localStorage.getItem("token")){
        this.$router.push("/")
      }
      this.isLoginPage = true
    }
    else {
      this.isLoginPage = false
      if(!localStorage.getItem("token")){
        this.$router.push("/login")
      }
    }
  },  watch: {
    '$route'(newPath, oldPath) {
      document.title =  this.$route.meta.title  || 'Kabbik Admin'
      if(newPath.path==='/login'){
        this.isLoginPage = true
      }
      else {
        this.isLoginPage = false
      }
    }
  },

  methods: {

  }
}
</script>
<style >
@import "assets/css/all.min.scss";
@import "assets/css/common.scss";
@import "assets/css/vue-loading.scss";

</style>
